export default __webpack_public_path__ + "static/media/large.9a2b5b22.jpg";